import React from "react";
import StepForm from "../components/RenderForm/StepForm";

function AddInformation() {
  return (
    <div>
      <StepForm />
    </div>
  );
}

export default AddInformation;
